require([
    'jquery',
    'ch_simple_filters',
    'filter/CourseRows',
    'ch_ga',
    'services',
    'semantic',
    'unveil',
    'ch_semantic_wishlist',
    'ch_email_wishlist',
    'ch_utils',
    'ch_header',
    'ch_scrollto',
    'ch_semantic_responsive',
    'ch_cookie',
    'bootstrap_affix',
], function($, simpleFilters, CourseRows, ga) {
    var triggerWishlistPopup = function() {
        var courseRows = $('.js-course-row');
        if (courseRows) {
            // Show popup only on one of the course row the user is scrolling through.
            var firstCourseRow = $(courseRows[0]);
            firstCourseRow.one('mouseenter', function () {
                var wishlistMenu = firstCourseRow.hasClass('no-sections') ?
                    $('.wishlist_text', firstCourseRow) :
                    $('.wishlist_heart', firstCourseRow);
                $(wishlistMenu).popup({
                    popup : $('#wishlist-alert-first-course'),
                    position: 'top center',
                    inline: true,
                    on: 'manual'
                }).popup('show');

                $(document).on('click', function() {
                    $(wishlistMenu).popup('hide');
                });

                CH.setCookie('ch_wln', 1);
            });
        }
    }

    // the thing that shows that the results are loading
    var $filterResultsLoader = $('.js-filter-loader');

    $(function () {

        ga(
            'send',
            'event',
            'Filter Click Positions',
            'Page loaded',
            CH.routeName,
            { nonInteraction: true }
        );

        var followCategory = function (showCategoryPreferencesWindow, showThankYouMessage, onlyFollow) {
            var isFollowing = $followCategoryButton.data('is-following');
            var followerCount = $categoryFollowerCount.html().replace(',', '');

            // toggle inverted on the desktop version of this button
            $followCategoryButton
                .filter('.mobile-hide')
                .toggleClass('inverted', !CH.isCategoryFollowed);

            if (!CH.category.id || $followCategoryButton.hasClass('loading')) {
                return false;
            }

            $.ajax({
                url: '/user/category/toggle-category',
                method: 'POST',
                data: {
                    category_id: CH.category.id,
                    only_follow: onlyFollow
                },
                beforeSend: function() {
                    $followCategoryButton
                        .addClass('loading');
                },
                success: function (res) {
                    $followCategoryButton
                        .removeClass('loading');

                    if (!res.success && res.error) {
                        new ModalMessage({message: res.error});
                        return;
                    }

                   // switch following state
                   isFollowing = !isFollowing;

                    // reverse the text
                    $followCategoryButton.html(
                        isFollowing
                            ? $followCategoryButton.data('following-text')
                            : $followCategoryButton.data('follow-text')
                        );

                    // toggle inverted on the desktop version of this button
                    $followCategoryButton
                        .filter('.mobile-hide')
                        .toggleClass('inverted', !isFollowing);

                    // update the count
                    if (isFollowing) {
                        followerCount++;
                    } else {
                        followerCount--;
                        if (followerCount < 0) {
                            followerCount = 0;
                        }
                    }
                    $categoryFollowerCount.html(numberFormat(followerCount));

                    $followCategoryButton.data('is-following', isFollowing);

                    if (showCategoryPreferencesWindow) {
                        CH.showCategoryPreferencesWindow();
                    }

                    if (showThankYouMessage) {
                        new ModalMessage({
                            message: 'Awesome! You are now following ' + CH.category.name + ' ' + CH.category.type + '.'
                        });
                    }
                }
            });
        };

        // Initialize category follow buttons and text

        var $categoryFollowerCount = $('.js-category-follower-count');

        $categoryFollowerCount.html(numberFormat(CH.followerCount));

        var $followCategoryButton = $('.js-follow-category');

        $followCategoryButton
            .html(
                CH.isCategoryFollowed
                    ? $followCategoryButton.data('following-text')
                    : $followCategoryButton.data('follow-text')
            )
            .data(
                'is-following',
                CH.isCategoryFollowed
            )
            .on('click', function (e) {
                e.preventDefault();

                if (!CH.getCookie('ch_i', { path: '/' })) {
                    var ModalWindowCategoryFollowSignupObj = new ModalWindowCategoryFollowSignup();
                    ModalWindowCategoryFollowSignupObj.show({
                        onSuccess: $.proxy(followCategory, this, true, false),
                    });

                    return;
                }

                followCategory(true, false);
            });

        // toggle inverted on the desktop version of this button
        $followCategoryButton
            .filter('.mobile-hide')
            .toggleClass('inverted', !CH.isCategoryFollowed);


        // when user is triggering "Follow" via url param
        if (window.location.hash === '#follow' && !CH.isCategoryFollowed) {
            if (!CH.getCookie('ch_i',  { path: '/' })) {
                var ModalWindowCategoryFollowSignupObj = new ModalWindowCategoryFollowSignup();
                ModalWindowCategoryFollowSignupObj.show({
                    onSuccess: $.proxy(followCategory, this, false, true, true),
                });

                return;
            }

            followCategory(false, true);
        }

        // Newsletter email capture
        CH.validate('form_CaptureEmail_deals', {
            submitHandler: function (form) {
                $('body').maskElement('');
                $.ajax({
                    type: 'POST',
                    url: form.action,
                    data: $(form).serialize(),
                    xhrFields: {
                        withCredentials: true,
                    },
                    success: function (res) {
                        $('body').unmaskElement('');

                        if (!res.success && res.error) {
                            new ModalMessage({ message: res.error });
                            return;
                        }

                        // Send GA Event
                        ga('send', 'event', 'Email Capture', 'Subscribe', $._('funnel').val());

                        $._('form_CaptureEmail_deals').each(function (index, form) {
                            $(form.email).val('');
                            $(form).fadeOut(400, function () {});
                        });

                        CH.showCategoryPreferencesWindow();
                    },
                });
            },
        });
    });

    function initializeMessages() {
        $('.message .close', '#filter-page-container')
            .on('click', function() {
                $(this)
                    .closest('.message')
                    .transition('fade')
                ;
            });
    }

    // initialize the magic
    $(function() {
        const $rootElement = $('#filter-results');
        CourseRows.initRows($rootElement);
        CourseRows.loadSnippets(
            CH.courseIds,
            CH.providerIds
        );

        initializeMessages();

        // Show popup only once for new users only
        if (
            !CH.getCookie('ch_i') &&
            !CH.getCookie('ch_wln')
        ) {
            triggerWishlistPopup();
        }

        simpleFilters.init({
            resultsCb: function () {
                // refresh course rows after we get new results
                CourseRows.initRows($rootElement);
                // @todo - fix it up; this breaks the map filter
                //searchResultsUpdated && searchResultsUpdated(CH.browseResults);
            },
            popStateCb: function () {
                // @todo - fix it up; this breaks map
                //popStateCb && popStateCb();
            }
        });

        $('.quiz-flow-section >.button').on('click', function() {
            ga(
                'send',
                'event',
                'Filter Page Quiz Flow',
                'Quiz Banner - Filter Page',
                'Quiz Button Clicked - Filter Page',
                { nonInteraction: false }
            );
        });

        // track category ad/banner events
        $('.js-filter-category-banner').on('click', function() {
            ga(
                'send',
                'event',
                'Filter Page',
                'Category Banner Clicked',
                (CH.category && CH.category.name),
                { nonInteraction: false }
            );
        });

        if (CH.privateCourses && CH.privateCourses.length > 0) {
            ga(
                'send',
                'event',
                'Private courses - browse page',
                'Private courses loaded - For counting',
                CH.privateCourses.length,
                { nonInteraction: false }
            );

            CH.privateCourses.forEach(function(courseName) {
                ga(
                    'send',
                    'event',
                    'Private courses - browse page',
                    'Private courses loaded - For name list',
                    courseName,
                    { nonInteraction: false }
                );
            });
        }

        if (
            CH &&
            !CH.isMobile &&
            CH.isMapFilterTestOn &&
            $('.filter-simple').length
        ) {
            // @todo - find a way to trigger these outer functions from inside
            // @todo - pass in browse results or $rootElement
            require(['filter/BrowseMap', function(MapFilter) {
                MapFilter.init({
                    searchResultsUpdated: searchResultsUpdated,
                    popStateCb: popStateCb,
                });
            }])
        }

    });

    // track that this user saw unsellable inventory on their entry page
    if (CH.isFirstVisit()) {
        if (CH.coursesNotAcceptingEnrollmentsCount > 0) {
            ga(
                'send',
                'event',
                'Unsellable Inventory',
                'Landing On Filter Page Unsellable',
                CH.coursesNotAcceptingEnrollmentsCount,
                { nonInteraction: true }
            );
        } else {
            ga(
                'send',
                'event',
                'Unsellable Inventory',
                'Landing On Filter Page Sellable',
                0,
                { nonInteraction: true }
            );
        }
    }

    if (CH.coursesNotAcceptingEnrollmentsCount > 0) {
        ga(
            'send',
            'event',
            'Unsellable Inventory',
            'Filter Page with unsellable courses',
            CH.coursesNotAcceptingEnrollmentsCount,
            { nonInteraction: true }
        );
    }
});
